import Request from "../lib/request";

const baseUrl = process.env.REACT_APP_API_URL;

export const init = (type, project_id) => {
  let projectId = localStorage.getItem("project_id");
  if (project_id) {
    projectId = project_id;
  }
  return Request({
    method: "get",
    url: `${baseUrl}/projects/${projectId}/premium/init?type=${type}&old_version=0`,
    needToken: true
  });
};

export const calculatePrice = (data, projectId) => {
  return Request({
    method: "post",
    url: `${baseUrl}/projects/${projectId}/premium/calculatePrice?old_version=0`,
    needToken: true,
    data
  });
};

export const getList = () => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "get",
    url: `${baseUrl}/projects/${projectId}/premium/transactions?paginate=false`,
    needToken: true
  });
};

export const getByProject = () => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "get",
    url: `${baseUrl}/projects/${projectId}/premium/transactionsByProject`,
    needToken: true
  });
};

export const payStore = (data, project_id) => {
  let projectId = localStorage.getItem("project_id");
  if (project_id) {
    projectId = project_id;
  }
  return Request({
    method: 'post',
    url: `${baseUrl}/projects/${projectId}/premium/pay?old_version=0`,
    needToken: true,
    data: data
  });
};

export const getPromoCode = () => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "get",
    url: `${baseUrl}/projects/${projectId}/premium/promoCodes?paginate=false`,
    needToken: true
  });
};
